/*
 * @Description: 项目详情
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */

import { agentManager } from '@/api/ajax';
import { Notification, Loading } from 'element-ui';

import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';

const example = new TableRenderClass({ fields, search });

const openOrCloseUserProjectStatus = function(data) {
  const loadingInstance = Loading.service({ fullscreen: true });
  agentManager
    .openOrCloseUserProjectStatus(data)
    .catch(() => {
      loadingInstance.close();
    })
    .then(res => {
      loadingInstance.close();
      if (res.data.status === '1') {
        Notification({
          message: '操作成功',
          type: 'success'
        });
        // 刷新当前列表
        this.$parent.saveSuccess();
        // 刷新index入口列表
        this.indexPage.$children[0].saveSuccess();
      }
    });
};

const allHandler = {
  name: '全部开启',
  render(h, ctx) {
    const parent = ctx.parent;
    const { userId } = parent.defaultQuery;
    return (
      <div style="width: 100%;margin-bottom: 15px;text-align:right">
        <el-button
          class="btn"
          type="primary"
          onClick={openOrCloseUserProjectStatus.bind(parent, {
            userId,
            status: 1
          })}
        >
          全部开启
        </el-button>
        <el-button
          class="btn"
          type="primary"
          onClick={openOrCloseUserProjectStatus.bind(parent, {
            userId,
            status: 2
          })}
        >
          全部关闭
        </el-button>
      </div>
    );
  }
};

const part = example.createPart({
  name: '项目详情',
  list: agentManager.projectInfoJoined,
  requestNow: true,
  fields: ['index', 'projectName', 'status'],
  moreBtnArr: [allHandler]
});

export default [{ name: '项目详情', childMenu: [part] }];
